import { geographyJson, stateList } from 'src/static/geography'
import {
  application,
  getLocalStorage,
  isB2B2CAdmin,
  filterWhiteLabelEmails,
  i18nTranslate,
  convertToBoolean,
  getInputFormJSON,
  enablePhoneVerificationInProfileUpdate,
} from 'src/utils'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { getReadOnlyFields } from 'src/utils/signUpUtils'
import {
  customerContainer,
  storeContainer,
  accountsContainer,
} from 'src/models'
import { APPConfig } from 'config/appConfig'
//import parsePhoneNumber from 'libphonenumber-js'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import { enablePhoneVerification, getParsedPhoneNumber } from 'src/utils'
// import i18n from 'i18next'

const addressFormInput = async (userResponse, onClickPhoneVerifyBtn) => {
  const {
    accountPrefillData,
    accountSettings,
    identity,
    addressData,
    sponsorId,
    handleCountryChange,
    isAddressDisabled,
  } = userResponse
  const identityExist = identity?.accounts

  const email2 = identityExist ? getLocalStorage('admnEmail') : ''
  const phoneNumber2 = identityExist ? getLocalStorage('admnPhoneNumber') : ''
  const getlocal = getLocaleCodeFromUrl({
    defaultLocale: 'en_US',
    isReverseType: true,
  })
  const locale = APPConfig?.getActiveAppConfig()?.defaultLocale //en_US
  const country = getlocal?.split('_').length ? getlocal?.split('_')[1] : ''
  const commonConfigJSON = getInputFormJSON(locale) || {}
  const disableFirstNameField = getReadOnlyFields('firstNameReadOnly', country)
  const disableLastNameField = getReadOnlyFields('lastNameReadOnly', country)
  const { name, typeId, size, dunsNumber, taxNumber } =
    accountPrefillData?.accountInfo || {}
  const { accountTypes, collectionProperties } = accountSettings || {}
  const accType = accountTypes && accountTypes.find(list => list.id === typeId)
  const acctype1 = getLocalStorage('accountType')
  const {
    lastName = '',
    phoneNumber = '',
    email = '',
    phoneCountry = '',
    parsedPhoneNumber = '',
  } = identity || {}
  const isBusinessEntity = acctype1 === 'Brand Affiliate - Business Entity'
  const accountParsedPhoneNumber = await getParsedPhoneNumber(
    accountPrefillData?.accountInfo?.phoneNumber || ''
  )
  const accountPhone = isBusinessEntity
    ? accountParsedPhoneNumber?.phoneNumberCode || ''
    : parsedPhoneNumber
  const parsedPhoneCountry = isBusinessEntity
    ? accountParsedPhoneNumber?.phoneCountry
    : phoneCountry
  let accountEmail = ''
  if (isBusinessEntity) {
    const properties = accountPrefillData?.accountInfo?.properties || []
    const businessEmailProp = properties.find(
      prop => prop.attributeId === 'businessEmail'
    )
    accountEmail = businessEmailProp?.value || ''
  } else {
    accountEmail = email
  }
  //Start of parse phonenumber code
  let userCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element.attributeId === 'countryCode') {
      userCountry = element.value
    }
  })
  const localCountry = userCountry
    ? userCountry
    : storeContainer?.storeIDValue === 'Canada'
      ? 'CA'
      : storeContainer?.storeIDValue
  let inputCode = countryData()?.find(
    element => element.value === localCountry
  )?.value
  let phoneNumberCode = accountPhone

  if (accountPhone) {
    inputCode = parsedPhoneCountry || inputCode
  }
  let phoneCountryCodeOptions = []
  countryData()?.forEach(val => phoneCountryCodeOptions.push(val))
  //End of parse phonenumber code

  let { state = '', addressId = '', accountId = '' } = addressData
  if (addressId === '' && accountId === '') {
    addressId =
      accountsContainer?.profileResponse?.addresses?.[0]?.addressId || ''
    accountId =
      accountsContainer?.profileResponse?.addresses?.[0]?.accountId || ''
  }

  const stateToLowerCase = state ? state.toLowerCase().replace(/\s/, '') : ''
  const defaultState =
    stateList[stateToLowerCase] !== undefined
      ? stateList[stateToLowerCase]
      : state
  /**
   * @note
   * NUSKIN-1054 - Change 'Canada' to 'CA' in PostData of Address Call
   */
  const geoData = geographyJson(true)
  let storeIdBasedOnCountry = storeContainer.storeIDValue
  storeIdBasedOnCountry =
    storeIdBasedOnCountry.toLowerCase() === 'canada'
      ? 'CA'
      : storeIdBasedOnCountry
  let homeCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element.attributeId === 'countryCode') {
      homeCountry = element.value
    }
  })

  let countryName = homeCountry || storeContainer.storeIDValue
  countryName = countryName?.toLowerCase() === 'canada' ? 'CA' : countryName
  if (homeCountry === 'CA') {
    homeCountry = 'Canada'
  }
  const isHomeCountry = homeCountry === storeContainer?.storeIDValue
  const enableJITSU = convertToBoolean(APPConfig?.getAppConfig()?.enableJITSU)
  const isBrandAffiliate = acctype1 === 'Brand Affiliate'
  const emailType = isBusinessEntity ? '' : 'accEmail'
  const firstName = isBusinessEntity
    ? identityExist
      ? name
      : ''
    : identity?.firstName

  const disableFnLn = isBrandAffiliate || isBusinessEntity ? true : false
  const emailLable = isBusinessEntity ? 'businessEmail' : 'email'
  const phoneLable = isBusinessEntity
    ? 'businessPhoneNumber'
    : 'mobilePhoneNumber'
  const emailPlaceHolder = isBusinessEntity
    ? 'businessEmailAddress'
    : 'userEmailAddress'
  const phonePlaceHolder = isBusinessEntity
    ? 'businessPhoneNumberPlaceHolder'
    : 'phoneNumberPlaceHolder'
  const displayBE = isBusinessEntity ? 'd-none' : ''
  const nameLable = isBusinessEntity ? 'bEFirstName' : 'firstName'
  const namePlaceholder = isBusinessEntity
    ? 'bEFirstNamePlaceHolder'
    : 'firstNamePlaceHolder'
  const addressHead = isBusinessEntity ? 'businessAddress' : 'legalAddress'
  const personType =
    customerContainer?.profileResponse?.customProperties?.personType?.toLowerCase()
  let notAddress = countryName !== storeIdBasedOnCountry ? true : false
  let convertAccountBtn
  if (acctype1 === 'Retail Customer' && countryName === storeIdBasedOnCountry) {
    convertAccountBtn = ''
  } else if (isBrandAffiliate && countryName === storeIdBasedOnCountry) {
    convertAccountBtn = ''
  } else {
    convertAccountBtn = 'd-none'
  }

  if (sponsorId == 'RETFLOAT') {
    convertAccountBtn = 'd-none'
  }

  const isToEnableEmailVerification =
    APPConfig?.getAppConfig()?.enableEmailVerification == 'true' || false

  const isEmailVerified = identity?.customProperties?.isEmailVerifiedFlag || ''
  let showEmailVerificationStatus = ''
  if (isEmailVerified === 'true') {
    showEmailVerificationStatus = 'valEmail'
  } else {
    showEmailVerificationStatus = 'notValEmail'
  }
  const isPhoneNumberVerified =
    identity?.customProperties?.isPhoneNumberVerified || ''
  let showPhoneVerificationStatus = ''
  if (isPhoneNumberVerified === 'true') {
    showPhoneVerificationStatus = 'valPhone'
  } else {
    showPhoneVerificationStatus = 'notValPhone'
  }

  let addExtraSpaceInEmail = ''
  let addExtraSpaceInPhone = ''

  if (
    (isEmailVerified === 'false' && isPhoneNumberVerified === 'false') ||
    (isEmailVerified === 'false' && isPhoneNumberVerified === '') ||
    (isEmailVerified === 'true' && isPhoneNumberVerified === '')
  ) {
    addExtraSpaceInEmail = 'd-none'
  } else if (isEmailVerified === 'false' && isPhoneNumberVerified === 'true') {
    addExtraSpaceInPhone = 'addPhoneSpace'
  } else if (isEmailVerified === 'true' && isPhoneNumberVerified === 'true') {
    addExtraSpaceInEmail = 'addEmailSpaceAllTrue'
  } else if (isEmailVerified === 'true' && isPhoneNumberVerified === 'false') {
    addExtraSpaceInEmail = 'addEmailSpaceTrue'
  } else if (isEmailVerified === 'true' && isPhoneNumberVerified === '') {
    addExtraSpaceInEmail = 'addEmailSpaceNoPhone'
  } else {
    addExtraSpaceInEmail = addExtraSpaceInPhone = 'd-none'
  }

  const countryCodeLabel = 'phoneCountryCode'
  const verifyBtnLabel = 'Verify'
  customerContainer.setVerifyPhone = {
    phoneCountryCode: inputCode,
    phoneNumber: !isB2B2CAdmin() ? phoneNumber2 : phoneNumberCode,
    name: firstName,
  }
  if (enablePhoneVerification()) {
    return [
      [
        {
          name: 'accountId',
          defaultValue: accountId,
          customClassName: 'd-none',
        },
        {
          name: 'addressId',
          defaultValue: addressId,
          customClassName: 'd-none',
        },
        {
          type: 'div',
          name: i18nTranslate(
            'accountProfile.lglAddressTitle',
            'Account Information'
          ),
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 h1 accountInfo',
        },
        {
          name: 'required_note',
          type: 'div',
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 required-note',
        },
        {
          //important//if account type is Brand Affiliate then he can't edit First Name (disabled)--Done
          name: nameLable,
          columnType: {
            lg: `${isBusinessEntity ? '12' : '6'}`,
          },
          disabled:
            !isB2B2CAdmin() ||
            countryName !== storeIdBasedOnCountry ||
            personType !== 'primary' ||
            disableFirstNameField
              ? true
              : disableFnLn,
          defaultValue: firstName,
          dataTestId: 'qa-first-name',
          placeholderKey: namePlaceholder,
          ariaLabel: nameLable,
          maxLength: commonConfigJSON?.name?.maxLength || 35,
          required: true,
        },
        {
          //important//Last Name(we need to pull in "account name" from SAP and label it as "Business name" for a Business Entity).
          //important//if account type is Brand Affiliate then he can't edit Last Name (disabled)--Done
          name: 'lastName',
          columnType: {
            lg: '6',
          },
          disabled:
            !isB2B2CAdmin() ||
            countryName !== storeIdBasedOnCountry ||
            personType !== 'primary' ||
            disableLastNameField
              ? true
              : disableFnLn,
          defaultValue: lastName,
          dataTestId: 'qa-last-name',
          placeholderKey: 'lastNamePlaceHolder',
          ariaLabel: 'lastName',
          maxLength: commonConfigJSON?.name?.maxLength || 35,
          customClassName: displayBE,
          required: true,
        },
      ],
      [
        {
          type: 'div',
          name: i18nTranslate('profileData.email', 'Email'),
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 h1 emailInfo',
        },
        {
          name: 'required_note',
          type: 'div',
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 required-note',
        },
        {
          //important//Y- this could be different from email under customer user tab.
          //important//This is NOT the email with which primary owner logs in with
          name: emailLable,
          type: emailType,
          columnType: {
            lg: '12',
          },
          maxLength: commonConfigJSON?.email?.maxLength || 256,
          defaultValue: filterWhiteLabelEmails({
            email: !isB2B2CAdmin() ? email2 : accountEmail,
          }),
          // defaultValue: !isB2B2CAdmin() ? email2 : accountEmail,
          dataTestId: 'qa-createaccount-email',
          ariaLabel: emailLable,
          placeholderKey: emailPlaceHolder,
          disabled:
            isBusinessEntity ||
            !isToEnableEmailVerification ||
            personType !== 'primary'
              ? true
              : isAddressDisabled,
          required: true,
          customClassName: 'add-box-height',
        },
        isB2B2CAdmin() && {
          type: showEmailVerificationStatus + 'SMSVerify',
          isToHideLabel: true,
          columnType: {
            lg: '12',
          },
        },
        {
          type: 'div',
          isToHideLabel: true,
          columnType: {
            lg: '12',
          },
          customClassName: `${addExtraSpaceInEmail}`,
        },
      ].filter(Boolean),
      [
        {
          type: 'div',
          name: i18nTranslate('profileData.phoneNumber', 'Phone Number'),
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 h1 phoneInfo',
        },
        {
          name: 'required_note',
          type: 'div',
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 required-note',
        },
        {
          name: countryCodeLabel,
          type: 'select',
          options: [...phoneCountryCodeOptions],
          columnType: {
            lg: `${
              application.width > 1024 && application.width < 1080 ? '6' : '4'
            }`,
          },
          dataTestId: 'qa-dropdown-countrycode',
          defaultValue: inputCode,
          ariaLabel: countryCodeLabel,
          required: true,
          phoneNumberDropDown: true,
          disabled: personType !== 'primary' ? true : isAddressDisabled,
          onInput: event => {
            customerContainer.setVerifyPhone.phoneCountryCode =
              event?.target?.value
          },
        },
        {
          name: phoneLable,
          columnType: {
            lg: `${
              application.width > 1024 && application.width < 1080 ? '6' : '8'
            }`,
          },
          dataTestId: 'qa-create-account-phone',
          placeholderKey: phonePlaceHolder,
          defaultValue: !isB2B2CAdmin() ? phoneNumber2 : phoneNumberCode,
          ariaLabel: phoneLable,
          disabled: personType !== 'primary' ? true : isAddressDisabled,
          required: true,
          maxLength: 20,
          customClassName: `${
            application.width > 1024 && application.width < 1080
              ? 'pt-2 add-box-height'
              : 'add-box-height'
          }`,
          type: 'mask',
          verifyBtnLabel: verifyBtnLabel,
        },
        enablePhoneVerificationInProfileUpdate() && {
          type: 'div',
          columnType: {
            lg: '12',
          },
          customClassName: 'labelInfoText',
          labelInfo: i18nTranslate(
                'phoneLabel.labelInfoText',
                "We'll text a code to verify this number. Fees may apply."
              )
        },
        {
          type: 'div',
          isToHideLabel: true,
          columnType: {
            lg: '12',
          },
          customClassName: `${addExtraSpaceInPhone}`,
        },
        isB2B2CAdmin() && {
          type: showPhoneVerificationStatus,
          isToHideLabel: true,
          columnType: {
            lg: '12',
          },
        },
        isB2B2CAdmin() && {
          name: verifyBtnLabel,
          type: 'button',
          columnType: {
            lg: '12',
          },
          isToHideLabel: true,
          defaultValue: 'Verify',
          dataTestId: 'qa-verify-phone-button',
          value: i18nTranslate('account.verifyButton', 'Verify'),
          onClick: event => {
            const parentDOM = event.target.parentNode
            if (!parentDOM.classList.contains('disable')) {
              onClickPhoneVerifyBtn && onClickPhoneVerifyBtn()
            }
          },
          customClassName: `phoneVerifyBtn my-1 ${
            !phoneNumberCode ? 'disable' : ''
          } ${showPhoneVerificationStatus === 'notValPhone' ? '' : 'd-none'}`,
        },
      ].filter(Boolean),
      [
        {
          type: 'div',
          name: i18nTranslate('address', 'Address'),
          columnType: {
            lg: '12',
          },
          customClassName: 'my-1 h1 addressInfo',
        },
      ],
    ]
  }

  return [
    [
      {
        name: 'accountId',
        defaultValue: accountId,
        customClassName: 'd-none',
      },
      {
        name: 'addressId',
        defaultValue: addressId,
        customClassName: 'd-none',
      },
      {
        //important//if account type is Brand Affiliate then he can't edit First Name (disabled)--Done
        name: nameLable,
        columnType: {
          lg: '6',
        },
        disabled:
          !isB2B2CAdmin() ||
          countryName !== storeIdBasedOnCountry ||
          personType !== 'primary' ||
          disableFirstNameField
            ? true
            : disableFnLn,
        defaultValue: firstName,
        dataTestId: 'qa-first-name',
        placeholderKey: namePlaceholder,
        ariaLabel: nameLable,
        maxLength: 35,
        required: true,
      },
      {
        //important//Last Name(we need to pull in "account name" from SAP and label it as "Business name" for a Business Entity).
        //important//if account type is Brand Affiliate then he can't edit Last Name (disabled)--Done
        name: 'lastName',
        columnType: {
          lg: '6',
        },
        disabled:
          !isB2B2CAdmin() ||
          countryName !== storeIdBasedOnCountry ||
          personType !== 'primary' ||
          disableLastNameField
            ? true
            : disableFnLn,
        defaultValue: lastName,
        dataTestId: 'qa-last-name',
        placeholderKey: 'lastNamePlaceHolder',
        ariaLabel: 'lastName',
        maxLength: 35,
        customClassName: displayBE,
        required: true,
      },
    ],
    [
      {
        //important//Y- this could be different from email under customer user tab.
        //important//This is NOT the email with which primary owner logs in with
        name: emailLable,
        type: emailType,
        columnType: {
          lg: '6',
        },
        maxLength: 256,
        defaultValue: filterWhiteLabelEmails({
          email: !isB2B2CAdmin() ? email2 : accountEmail,
        }),
        // defaultValue: !isB2B2CAdmin() ? email2 : accountEmail,
        dataTestId: 'qa-createaccount-email',
        ariaLabel: emailLable,
        placeholderKey: emailPlaceHolder,
        disabled:
          isBusinessEntity ||
          !isToEnableEmailVerification ||
          personType !== 'primary'
            ? true
            : isAddressDisabled,
        required: true,
      },
      {
        name: 'phoneCountryCode',
        type: 'select',
        options: [...phoneCountryCodeOptions],
        columnType: {
          lg: `${
            application.width > 1024 && application.width < 1080 ? '6' : '2'
          }`,
        },
        dataTestId: 'qa-dropdown-countrycode',
        defaultValue: inputCode,
        ariaLabel: 'phoneCountryCode',
        required: true,
        phoneNumberDropDown: true,
        disabled: personType !== 'primary' ? true : isAddressDisabled,
      },
      {
        name: phoneLable,
        columnType: {
          lg: `${
            application.width > 1024 && application.width < 1080 ? '6' : '4'
          }`,
        },
        dataTestId: 'qa-create-account-phone',
        placeholderKey: phonePlaceHolder,
        defaultValue: !isB2B2CAdmin() ? phoneNumber2 : phoneNumberCode,
        ariaLabel: phoneLable,
        disabled: personType !== 'primary' ? true : isAddressDisabled,
        required: true,
        maxLength: 20,
        customClassName: `${
          application.width > 1024 && application.width < 1080 ? 'pt-2' : ''
        }`,
        type: 'mask',
      },
      {
        type: 'div',
        isToHideLabel: true,
        columnType: {
          lg: '12',
        },
        customClassName: `${addExtraSpaceInPhone}`,
      },
    ],
    [
      {
        type: 'div',
        name: addressHead,
        columnType: {
          lg: '12',
        },
        customClassName: 'contact-info',
      },
    ],
  ]
}

export { addressFormInput }
